import React, { createContext, useContext, useState, useEffect } from 'react'
import { usePools } from '../hooks/usePools'

const PoolContext = createContext()

export const usePool = () => {
  const context = useContext(PoolContext)
  if (context === undefined) {
    throw new Error('usePool must be used within a PoolProvider')
  }
  return context
}

export const PoolProvider = ({ children }) => {
  const { pools, loading: poolsLoading } = usePools()
  const [selectedPool, setSelectedPool] = useState(null)

  useEffect(() => {
    // Auto-select first pool if no pool is currently selected and pools exist
    // Use functional updates to avoid selectedPool in the dependency array,
    // which would cause unnecessary re-renders on every selection change.
    setSelectedPool(current => {
      if (pools.length > 0 && !current) {
        return pools[0]
      }
      if (current && !pools.find(p => p.id === current.id)) {
        return null
      }
      return current
    })
  }, [pools])

  const value = {
    pools,
    selectedPool,
    setSelectedPool,
    loading: poolsLoading,
  }

  return (
    <PoolContext.Provider value={value}>
      {children}
    </PoolContext.Provider>
  )
}